__turbopack_context__.v({
  "header": "drawer-header-module-scss-module__YTiDjG__header",
  "header-content": "drawer-header-module-scss-module__YTiDjG__header-content",
});
